import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import TemporaryManagement from './pages/TemporaryManagement';
import ChiSiamo from './pages/ChiSiamo';
import { CasiStudioList, CasoStudioDetail } from './pages/CasiStudio';
import SviluppoBrand from './pages/SviluppoBrand';
import PocketAdmin from './pages/PocketAdmin';
import EcommerceEtico from './pages/EcommerceEtico';
import Egas from './pages/Egas';
import Contatti from './pages/Contatti';
import Admin from './pages/Admin';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main className="min-h-screen">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/temporary-management" element={<PublicLayout><TemporaryManagement /></PublicLayout>} />
          <Route path="/casi-studio" element={<PublicLayout><CasiStudioList /></PublicLayout>} />
          <Route path="/casi-studio/:slug" element={<PublicLayout><CasoStudioDetail /></PublicLayout>} />
          <Route path="/chi-siamo" element={<PublicLayout><ChiSiamo /></PublicLayout>} />
          <Route path="/ecommerce-etico" element={<PublicLayout><EcommerceEtico /></PublicLayout>} />
          <Route path="/sviluppo-brand" element={<PublicLayout><SviluppoBrand /></PublicLayout>} />
          <Route path="/pocket-administration" element={<PublicLayout><PocketAdmin /></PublicLayout>} />
          <Route path="/e-gas" element={<PublicLayout><Egas /></PublicLayout>} />
          <Route path="/contatti" element={<PublicLayout><Contatti /></PublicLayout>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
